import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Http, Headers } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  modalType: any;
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private afs: AngularFirestore,
    private http: Http,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  delete(): void {
    this.afs.collection('corporateLeads').doc(this.data.key).delete();
    this.dialogRef.close();


  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/corporate-leads/dialog/dialog.component.ts